class SocialProofCounter extends HTMLElement {
  constructor() {
    super();
    this.animated = false;
  }

  connectedCallback() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.animated) {
            this.animated = true;
            this.animateCounters();
            this.observer.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  animateCounters() {
    const counters = this.querySelectorAll('[data-count-target]');
    counters.forEach((el) => {
      const target = parseFloat(el.dataset.countTarget);
      const decimals = el.dataset.countDecimals ? parseInt(el.dataset.countDecimals) : 0;
      const duration = 2000;
      const startTime = performance.now();

      const update = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = eased * target;

        el.textContent = decimals > 0
          ? current.toFixed(decimals)
          : Math.floor(current).toLocaleString('ro-RO');

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          el.textContent = decimals > 0
            ? target.toFixed(decimals)
            : target.toLocaleString('ro-RO');
        }
      };

      requestAnimationFrame(update);
    });
  }
}

customElements.define('social-proof-counter', SocialProofCounter);
